import React from 'react';
import { styled } from 'styled-components';
import { Flex } from '../Flex/Flex';

export interface AppBarProps {
  children?: React.ReactNode;
}

export function AppBar(props: AppBarProps) {
  return (
    <StyledAppBar horizontal align="center">
      {props.children}
    </StyledAppBar>
  );
}

const StyledAppBar = styled(Flex)`
  color: ${(props) => props.theme.appbar.fg};
  background-color: ${(props) => props.theme.appbar.bg};
  box-shadow: rgba(17, 38, 146, 0.05) 0px 0px 30px 0px;

  // the min height and padding is set to match the DrawerHeader component
  // because they are likely to be used together.
  min-height: 64px;
  padding: 4px 16px;
`;
